import React from 'react'
import CellReturn from './CellReturn'
import { useEffect, useState } from 'react'
// import { useHistory } from 'react-router-dom'
import GetFormattedDateforlistmovies from './getFormateddateforlistmovies'
import Tablemodel from './tablemodel'
import { crewDataTe, crewDataEn, unEditedFeilds, crewArrayList } from '../Data/MovieStaticData'
import 'react-datepicker/dist/react-datepicker.css'
import GetmoviesAppInfoData from '../../Services/Queries/GetmoviesAppInfoConfigService'

function Cell({ value, dataValues, mode, onChange, path }) {
  const [rolename, setRolename] = useState()
  const [personName, setName] = useState()
  const [genresValues, setGenresValues] = useState()
  const [ottListValues, setOttListValues] = useState()
  const [personIdval, setpersonIdval] = useState()
  const [localMode, setLocalMode] = useState(mode ?? 'read')
  const [localValue, setLocalValue] = useState(value ?? '')

  useEffect(() => setLocalMode(mode ?? 'read'), [mode])
  useEffect(() => setLocalValue(value ?? ''), [value])
  const [copy, setcopy] = useState()
  const [generSelectedArray, setgenerSelectedArray] = useState(
    path === 'genre_Te' || path === 'genre_En' ? (value ? value : []) : [],
  )
  //
  const [OttSelectedArray, setOttSelectedArray] = useState(path === 'ottPlatform' ? value : [])
  const [pop, setpop] = useState(false)

  function Doubleclickchip(personID) {
    window.open('editperson?' + encodeURI(personID))
  }

  function singleClickcast(localval, personID, rolename) {
    setLocalMode('edit')
    setpersonIdval(personID)
    setRolename(rolename)
    setcopy(localval)
  }

  const [date, setDateDate] = useState(GetFormattedDateforlistmovies(localValue))
  const onDateChange = event => {
    let dateValue = event.target.value
    if (dateValue.length === 0) {
      dateValue = 0
      setDateDate(dateValue)
      setLocalValue(dateValue)
    } else {
      setDateDate(dateValue)
      setLocalValue(Number(dateValue.replaceAll('-', '')))
    }
  }

  const [dateOtt, setDateDateOtt] = useState(GetFormattedDateforlistmovies(localValue))
  const onDateChangeOtt = event => {
    let getDate = event.target.value
    if (getDate.length === 0) {
      getDate = 0
      setDateDateOtt(getDate)
      setLocalValue(Number(getDate))
    } else {
      setDateDateOtt(event.target.value)
      setLocalValue(Number(getDate.replaceAll('-', '')))
    }
  }

  const [isReadMore, setIsReadMore] = useState(true)
  const toggleReadMore = () => {
    setIsReadMore(!isReadMore)
  }

  const [readmorecast, setreadmorecast] = useState(false)
  function readmoreforcast() {
    setreadmorecast(!readmorecast)
  }

  const editpop = () => {
    if (pop === true) {
      setpop(false)
    } else {
      setpop(true)
    }
  }

  if (localMode === 'edit') {
    const handleInputChange = data => {
      setLocalValue(data.target.value)
      setRolename(data.target.value)
      setName(data.target.value)
    }

    const handleSaveClick = () => {
      const allCrewArray = [
        ...(dataValues.movieCinematography ? dataValues.movieCinematography : []),
        ...(dataValues.movieDialogueBy ? dataValues.movieDialogueBy : []),
        ...(dataValues.movieDirectedBy ? dataValues.movieDirectedBy : []),
        ...(dataValues.movieEditedBy ? dataValues.movieEditedBy : []),
        ...(dataValues.movieMusicBy ? dataValues.movieMusicBy : []),
        ...(dataValues.movieProducedBy ? dataValues.movieProducedBy : []),
        ...(dataValues.movieScreenplayBy ? dataValues.movieScreenplayBy : []),
        ...(dataValues.movieStoryBy ? dataValues.movieStoryBy : []),
        ...(dataValues.movieWrittenBy ? dataValues.movieWrittenBy : []),
      ]

      const mapTofilterCast = copy
      if (crewArrayList.some(item => item === path)) {
        let pathArrayValues
        let movieRoleEn
        // eslint-disable-next-line array-callback-return
        mapTofilterCast.map(item => {
          delete item.__typename
          if (item.PK === null || item.SK === null) {
            item.PK = 'person#' + item.movieID
            item.SK = 'actor#' + item.personID
            return item
          }
        })
        let filteredArray = mapTofilterCast.filter(item => item.personID !== personIdval)
        let filteredPerticularMember = mapTofilterCast.filter(item => item.personID === personIdval)
        if (path === 'movieCast_Te') {
          filteredPerticularMember[0].roleName_Te = rolename
          filteredArray.push(filteredPerticularMember[0])
          setLocalMode('read')
          filteredArray.map(item =>
            Object.keys(item).forEach(key => {
              if (item[key] === null) {
                delete item[key]
              }

              delete item.movieRole_En
              delete item.movieRole_Te
              delete item.posterURL
            }),
          )

          // const filteredArrayObject = { filteredArray, filteredArrayval }
          onChange(filteredArray)
          //
        }

        if (path === 'movieCast') {
          filteredPerticularMember[0].roleName_En = rolename
          filteredArray.push(filteredPerticularMember[0])
          setLocalMode('read')
          filteredArray.map(item =>
            Object.keys(item).forEach(key => {
              if (item[key] === null) {
                delete item[key]
              }

              delete item.movieRole_En
              delete item.movieRole_Te
              delete item.posterURL
            }),
          )

          // const filteredArrayObject = { filteredArray, filteredArrayval }
          onChange(filteredArray)
          //
        }

        if (crewDataEn.some(item => item === path)) {
          filteredPerticularMember = allCrewArray.filter(item => item.personID === personIdval)
          filteredArray = allCrewArray.filter(item => item.personID !== personIdval)
          filteredPerticularMember[0].name_En = personName
          filteredArray.push(filteredPerticularMember[0])
          movieRoleEn = filteredPerticularMember[0].movieRole_En
          setLocalMode('read')
          filteredArray.map(item =>
            Object.keys(item).forEach(key => {
              if (item[key] === null) {
                delete item[key]
              }

              delete item.movieRole_Te
              delete item.posterURL
              delete item.__typename
            }),
          )
          pathArrayValues = filteredArray.filter(item => item.movieRole_En === movieRoleEn)
          const filterAndPathObj = { pathArrayValues, filteredArray }
          onChange(filterAndPathObj)
          //
        }

        if (crewDataTe.some(item => item === path)) {
          //
          filteredPerticularMember = allCrewArray.filter(item => item.personID === personIdval)
          filteredArray = allCrewArray.filter(item => item.personID !== personIdval)
          filteredPerticularMember[0].name_Te = personName
          movieRoleEn = filteredPerticularMember[0].movieRole_En
          filteredArray.push(filteredPerticularMember[0])
          setLocalMode('read')
          filteredArray.map(item =>
            Object.keys(item).forEach(key => {
              if (item[key] === null) {
                delete item[key]
              }

              delete item.__typename
              delete item.movieRole_Te
              delete item.posterURL
            }),
          )
          //
          pathArrayValues = filteredArray.filter(item => item.movieRole_En === movieRoleEn)
          //
          const filterAndPathObj = { pathArrayValues, filteredArray }
          onChange(filterAndPathObj)
          //
        }
      } /* (CastAndCrew.some(item => item !== path))  */ else {
        setLocalMode('read')
        // const filteredArray = localValue

        onChange?.(localValue)
        //
      }
    }

    const handlecancelClick = () => {
      if (path === 'genre_En' || path === 'genre_Te') {
        setgenerSelectedArray(value)
      }

      if (path === 'ottPlatform') {
        setOttSelectedArray(value)
      }

      setLocalValue(copy)
      setLocalMode('read')
    }

    const ageRestrictionChip = e => {
      setLocalValue(e.target.getAttribute('value'))
      // , 'e.target.getAttribute(')
    }

    new Date().setDate(new Date().getDate() + 7)

    const genreChip = e => {
      //
      const generSelectData = generSelectedArray ? [...generSelectedArray] : []
      const index = generSelectData.findIndex(item => item === e.target.getAttribute('value'))
      if (index > -1) {
        generSelectData.splice(index, 1)
        setgenerSelectedArray(generSelectData)
        setLocalValue(generSelectData.map(item => item))
      } else {
        //
        generSelectData.push(e.target.getAttribute('value'))
        setgenerSelectedArray(generSelectData)
        //

        setLocalValue(generSelectData.map(item => item))
      }
    }

    const ottPlatformFun = e => {
      const OttSelectData = OttSelectedArray ? [...OttSelectedArray] : []
      const upperCaseOttSelectData = OttSelectData.map(element => element.toLowerCase())

      //
      const index = upperCaseOttSelectData.findIndex(
        item => item === e.target.getAttribute('value'),
      )
      //
      if (index > -1) {
        upperCaseOttSelectData.splice(index, 1)
        setOttSelectedArray(upperCaseOttSelectData)
        setLocalValue(upperCaseOttSelectData.map(item => item))
      } else {
        upperCaseOttSelectData.push(e.target.getAttribute('value'))
        setOttSelectedArray(upperCaseOttSelectData)

        setLocalValue(upperCaseOttSelectData.map(item => item))
      }
    }

    return (
      <Tablemodel
        ottListValues={ottListValues}
        genresValues={genresValues}
        rolename={rolename}
        editpop={editpop}
        setpop={setpop}
        path={path}
        localValue={localValue}
        ageRestrictionChip={ageRestrictionChip}
        genreChip={genreChip}
        dateOtt={dateOtt}
        onDateChangeOtt={onDateChangeOtt}
        date={date}
        onDateChange={onDateChange}
        ottPlatformFun={ottPlatformFun}
        handleInputChange={handleInputChange}
        handlecancelClick={handlecancelClick}
        handleSaveClick={handleSaveClick}
      />
    )
  }

  if (localMode === 'read') {
    const handleEditClick = async () => {
      const genreList = await GetmoviesAppInfoData()

      if (path === 'genre_En') {
        const genreobj = genreList.getMoviesAppInfoConfig.genres
        const genrearrayVla = genreobj && genreobj.map(item => item.label)
        setGenresValues(genrearrayVla)
      }
      // cell

      if (path === 'ottPlatform') {
        // const genreList = await GetmoviesAppInfoData()
        const ottListobj = genreList.getMoviesAppInfoConfig.ottList
        const ottListarrayVal = ottListobj && ottListobj.map(item => item.label.toLowerCase())
        setOttListValues(ottListarrayVal)
      }

      setcopy(localValue)
      setLocalMode('edit')
    }

    const isFound = unEditedFeilds.some(element => {
      if (element === path) {
        return true
      }

      return undefined
    })
    // const DisableUrlFeilds = ['posterURL']
    const isFoundPOsterURL = ['posterURL'].some(element => {
      if (element === path) {
        return true
      }

      return undefined
    })

    return (
      <CellReturn
        readmoreforcast={readmoreforcast}
        value={value}
        readmorecast={readmorecast}
        path={path}
        isFoundPOsterURL={isFoundPOsterURL}
        isReadMore={isReadMore}
        GetFormattedDateforlistmovies={GetFormattedDateforlistmovies}
        localValue={localValue}
        Doubleclickchip={Doubleclickchip}
        singleClickcast={singleClickcast}
        toggleReadMore={toggleReadMore}
        isFound={isFound}
        handleEditClick={handleEditClick}
      />
    )
  }

  return null
}

export default Cell
